import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import * as generic from '../../../components/Generico';
import { ClientePJService } from '../../../service/ClientePJService';
import { InputComponent } from '../../../components/InputComponent';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { FileComponent } from '../../../components/FileComponent';
import { DeclaracionCpj } from '../../../models/cpj/DeclaracionCpj';
import { Dialog } from 'primereact/dialog';
import { AnexosComponent } from '../../../components/AnexosComponent';
import { VisorPdf } from "../../../components/VisorPdf";
import { BottomActionBar } from '../../../components/ui/BottomActionBar';

export const Declaracion = ({ toast, nuevo, id, back, setDialogClientepj, permss, cancelar, setdialogIns, urls, estado, reiniciar, soloLectura, tipoFrmEmpresa, anexosRequisitosNacional,
    anexosRequisitosExtranjero
}) => {

    const omodel = new DeclaracionCpj();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError } = useForm({ defaultValues });
    const clientepjSrv = new ClientePJService();
    const { inArea } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const { enviarFormulario } =
        FileComponent({ tipo: 'clientePj', toast, unuevo: 'ficha/clientepj/store', udelete: 'ficha/clientepj/eliminar-anexo', permss, id });
    const [loadReport, setLoadReport] = useState(false);
    const [dialogAnexos, setDialogAnexos] = useState(false);
    const [dialogVisor, setDialogVisor] = useState(false);
    const [pdfUrl, setPdfUrl] = useState({ url: null, name: '' });
    const [firmaActiva, setFirmaActiva] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id])

    const editFicha = () => {
        setIsLoading(true);
        clientepjSrv.consultarClientepj(id, 'p8').then(res => {
            if (res.data.firmaActiva) {
                setFirmaActiva(res.data.firmaActiva);
            }
            reset(generic.renewValues(res.data.clientepj, omodel.model));
        }).finally(() => {
            setIsLoading(false)
        });
    }

    const onSubmit = (data) => {
        data.paso = 'p8';
        data.id = id;
        setIsSaving(true);
        clientepjSrv.editarClientepj(data).then(res => {
            setdialogIns(true);
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => {
            setIsSaving(false);
        });
    }

    const descargarDocumento = (firmar = false) => {
        setLoadReport(true);
        // Si firmar es false y estado es "ENVIADO" recuperará el archivo subido formulario principal
        // Solo entra a esta función si el estado es "ENVIADO" y si la firma está activada
        clientepjSrv.descargar(id, firmar, estado).then(res => {
            const blob = new Blob([res], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(blob);
            const fileName = id + '-Formulario-cliente-PJ-firmado.pdf';
            setPdfUrl({ url: fileURL, name: fileName });
            setDialogVisor(true);
        }).catch(error => {
            generic.funcMessageBlobError('Complete la información antes de generar.', error, toast);
        }).finally(() => setLoadReport(false));
    };

    const generarReporte = (firmar = false) => {
        setLoadReport(true);

        // ID se pasa como props
        if (!firmaActiva) {
            // Firma desactivada: descarga sin visor
            clientepjSrv.descargar(id, firmar, null, { tipoFrmEmpresa }).then(res => {
                generic.downloadPdf(res, `${id}-Formulario-cliente-PJ.pdf`);
            }).catch(error => {
                generic.funcMessageBlobError('Complete la información antes de generar.', error, toast);
            }).finally(() => setLoadReport(false));
            return;
        }

        // Firma activada: si el formulario está enviado, descarga documento existente
        if (estado === "ENVIADO") {
            descargarDocumento(false);
            // La funcion se encarga de poner setLoadReport(false);
            return;
        }

        // Firma activa y formulario en borrador: genera PDF y muestra visor
        clientepjSrv.descargar(id, firmar, null, { tipoFrmEmpresa }).then(res => {
            const blob = new Blob([res], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(blob);
            const fileName = `${id}-Formulario-cliente-PJ.pdf`;
            setPdfUrl({ url: fileURL, name: fileName });
            setDialogVisor(true);
        }).catch(error => {
            generic.funcMessageBlobError('Complete la información antes de generar.', error, toast);
        }).finally(() => setLoadReport(false));
    }

    const subirReporte = () => {
        setDialogAnexos(true);
    }

    const enviar = () => {
        enviarFormulario(id, `ficha/clientepj/enviar?tipoFrmEmpresa=${tipoFrmEmpresa}`, 'clientePj');
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <>
            <form id="declaracionPjForm" onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
                <Panel header="PARTE D" className="panel-ficha mb-4">
                    <Panel header={generic.renderPanelHeader('D.1', 'DECLARACIÓN DE ORIGEN LÍCITO DE FONDOS', 'pi pi-file-edit')} className="panel-ficha shadow-1 mb-4">
                        <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                            <div className="flex align-items-center gap-2 mb-3">
                                <i className="pi pi-info-circle text-blue-600 text-lg"></i>
                                <span className="font-bold text-blue-900">Términos de la Declaración</span>
                            </div>
                            {omodel.strDeclara}
                        </div>
                    </Panel>

                    <Panel header={generic.renderPanelHeader('D.2', 'AUTORIZACIÓN PARA TRATAMIENTO DE DATOS', 'pi pi-lock')} className="panel-ficha shadow-1 mb-4">
                        <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                            <div className="flex align-items-center gap-2 mb-3">
                                <i className="pi pi-shield text-blue-600 text-lg"></i>
                                <span className="font-bold text-blue-900">Tratamiento de Datos Personales</span>
                            </div>
                            {!['FRM_TOYOTA', 'FRM_DIFARE'].includes(tipoFrmEmpresa) && omodel.strAutorizacionTratamientoDatos}
                            {tipoFrmEmpresa === 'FRM_TOYOTA' && omodel.strToyota}
                            {tipoFrmEmpresa === 'FRM_DIFARE' && omodel.strDifare}
                        </div>
                    </Panel>

                    {!['FRM_TOYOTA', 'FRM_DIFARE'].includes(tipoFrmEmpresa) && (
                        <Panel header={generic.renderPanelHeader('', 'OBSERVACIONES', 'pi pi-comment')} className="panel-ficha shadow-1 mb-4">
                            <div className="formgrid grid p-2">
                                {inArea('observacion', 5, 9000, 12)}
                            </div>
                        </Panel>
                    )}

                    <Panel header={generic.renderPanelHeader('8', 'Anexos', 'pi pi-paperclip')} className="panel-ficha shadow-1">
                        <div className="formgrid grid">
                            <div className="col-12 md:col-6">
                                <div className="h-full p-3 text-justify line-height-3 text-700 bg-yellow-50 border-round border-left-3 border-yellow-500">
                                    <div className="flex align-items-center gap-2 mb-3">
                                        <i className="pi pi-file text-yellow-600 text-lg"></i>
                                        <span className="font-bold text-yellow-900">Persona Jurídica Nacional</span>
                                    </div>
                                    <ul className="pl-4 m-0">
                                        {anexosRequisitosNacional.map((req, index) => (
                                            <li key={index} className="mb-1">{req}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            <div className="col-12 md:col-6 mt-3 md:mt-0">
                                <div className="h-full p-3 text-justify line-height-3 text-700 bg-yellow-50 border-round border-left-3 border-yellow-500">
                                    <div className="flex align-items-center gap-2 mb-3">
                                        <i className="pi pi-file text-yellow-600 text-lg"></i>
                                        <span className="font-bold text-yellow-900">Persona Jurídica Extranjera</span>
                                    </div>
                                    <ul className="pl-4 m-0">
                                        {anexosRequisitosExtranjero.map((req, index) => (
                                            <li key={index} className="mb-1">{req}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            {['FRM_TOYOTA', 'FRM_DIFARE'].includes(tipoFrmEmpresa) && (
                                <div className="col-12 mt-3">
                                    <div className="p-3 text-justify font-bold line-height-3 text-xs bg-yellow-50 border-round border-left-3 border-yellow-500">
                                        {omodel.msgAnexo}
                                    </div>
                                </div>
                            )}
                        </div>
                    </Panel>
                </Panel>

                <BottomActionBar
                    formId="declaracionPjForm"
                    onPrev={back}
                    onSave={!['FRM_TOYOTA', 'FRM_DIFARE'].includes(tipoFrmEmpresa)} // Solo muestra "Guardar" si hay algo que guardar
                    onGenerate={() => generarReporte(false)}
                    onSend={enviar}
                    onAttachments={subirReporte}
                    loading={loadReport || isSaving}
                    isReadOnly={soloLectura}
                    enableExtras={id != null} // Los botones de PDF, Enviar y Anexos solo aparecen si ya se guardó la ficha
                />
            </form >
            <Dialog visible={dialogAnexos} header="Gestión de Anexos" modal className="p-fluid modal-ssize" onHide={() => setDialogAnexos(false)} style={{ width: '800px' }}>
                <AnexosComponent tipo="clientePj" urls={urls} idp={id} toast={toast} permss={permss} setDialogSubir={setDialogAnexos} reiniciar={reiniciar} estado={estado} soloLectura={soloLectura} />
            </Dialog>
            <VisorPdf visible={dialogVisor} onHide={() => setDialogVisor(false)} fileBlobUrl={pdfUrl.url} fileName={pdfUrl.name} firmar={() => descargarDocumento(true)} firmarEnviar={() => enviar('firmarEnviar')} id={id} tipo='clientePj' urls={urls} toast={toast} />
        </>
    );
}